// src/pages/Dashboard/Dashboard.js
import React, { useState } from 'react';

// Ya NO importamos FilterBar ni los estados de filtros aquí

// 1. Importar los componentes de las pestañas
import TabResumenCompras from './Tabs/TabResumenCompras';
import TabAnalisisArticulos from './Tabs/TabAnalisisArticulos';
import TabAnalisisProveedores from './Tabs/TabAnalisisProveedores';

// Empresas disponibles y empresa inicial. Salen del .env, así que agregar una
// más no requiere tocar este archivo (sí recompilar: son REACT_APP_*).
const EMPRESAS = (process.env.REACT_APP_EMPRESAS || 'CIMSA')
  .split(',')
  .map(e => e.trim())
  .filter(Boolean);

const EMPRESA_INICIAL = process.env.REACT_APP_EMPRESA_DEFAULT || EMPRESAS[0] || 'CIMSA';

const Dashboard = () => {

  const [activeTab, setActiveTab] = useState('resumen'); // Pestaña activa
  // La empresa vive acá y baja a las pestañas: así las tres muestran siempre
  // la misma, y cambiarla recarga la que esté abierta.
  const [empresa, setEmpresa] = useState(EMPRESA_INICIAL);

  return (
    <div className="container-fluid">
      {/* La empresa se elige acá y aplica a las tres pestañas: el portal es
          multiempresa y los datos corresponden sólo a la seleccionada. */}
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mt-4">
        <h1 className="mb-0">Dashboard de Compras</h1>

        <div className="d-flex align-items-center gap-2">
          <label htmlFor="empresaSelect" className="form-label mb-0 text-muted">
            <i className="bi bi-building me-1"></i>
            Empresa
          </label>
          <select
            id="empresaSelect"
            className="form-select form-select-sm fw-semibold"
            style={{ width: 'auto' }}
            value={empresa}
            onChange={(e) => setEmpresa(e.target.value)}
          >
            {EMPRESAS.map(nombre => (
              <option key={nombre} value={nombre}>{nombre}</option>
            ))}
          </select>
        </div>
      </div>

      {/* 2. Navegación de Pestañas (Bootstrap) */}
      <ul className="nav nav-tabs mt-4">
        <li className="nav-item">
          <button 
            className={`nav-link ${activeTab === 'resumen' ? 'active' : ''}`}
            onClick={() => setActiveTab('resumen')}
          >
            <i className="bi bi-bar-chart-fill me-1"></i> Resumen de Compras
          </button>
        </li>
        <li className="nav-item">
          <button 
            className={`nav-link ${activeTab === 'articulos' ? 'active' : ''}`}
            onClick={() => setActiveTab('articulos')}
          >
            <i className="bi bi-box-seam me-1"></i> Análisis de Artículos
          </button>
        </li>
        <li className="nav-item">
          <button 
            className={`nav-link ${activeTab === 'proveedores' ? 'active' : ''}`}
            onClick={() => setActiveTab('proveedores')}
          >
            <i className="bi bi-truck me-1"></i> Análisis de Proveedores
          </button>
        </li>
      </ul>

      {/* 3. Contenido de las Pestañas (Renderizado Condicional) */}
      {/* Ahora cada componente de Pestaña es 100% independiente
        y maneja sus propios datos y filtros.
      */}
      <div className="tab-content">
        {activeTab === 'resumen' && (
          <TabResumenCompras empresa={empresa} />
        )}
        {activeTab === 'articulos' && (
          <TabAnalisisArticulos empresa={empresa} />
        )}
        {activeTab === 'proveedores' && (
          <TabAnalisisProveedores empresa={empresa} />
        )}
      </div>
      
    </div>
  );
};

export default Dashboard;